<template>
  <vehicle-ref-standardized
    :vehicle="repair.vehicle"
    @vehicleChanged="$emit('vehicleChanged')"
    gallery-selector
  >
    <template #second-title>
      <h4>{{ title ?? repair.code }}</h4>
    </template>

    <template #buttons>
      <slot name="buttons">
        <!--<button v-if="canCancel" @click="$emit('cancel')" class="delete">
        <span> {{ $t("COMMON.CANCEL") }} </span>
        <i class="far fa-trash-alt"></i>
      </button>-->
        <button v-if="canEdit" @click="$emit('edit')" class="edit">
          <span> {{ $t("COMMON.UPDATE") }} </span>
          <i class="far fa-edit"></i>
        </button>
        <button v-if="canView" @click="view" class="edit">
          <span> {{ $t("ESTIMATES.SHOW_ESTIMATE") }} </span>
          <i class="fa-light fa-eye"></i>
        </button>
      </slot>
    </template>
  </vehicle-ref-standardized>
</template>

<script>
import { QUERY_ACTIONS_EDIT } from "@/constants/common";
import VehicleRefStandardized from "./VehicleRefStandardized.vue";

export default {
  name: "repair-ref-standardized",

  components: { VehicleRefStandardized },

  props: {
    repair: {
      type: Object,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canView: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      QUERY_ACTIONS_EDIT,
    };
  },

  computed: {},

  methods: {
    view() {
      this.$emit("onView");
      if (this.$route.name != "List Repairs") {
        this.$router.push({
          name: "List Repairs",
          query: { id: this.repair.id, action: QUERY_ACTIONS_EDIT },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
